// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"loader_loader-wrapper__338oL","loader-image":"loader_loader-image__1e1rC","timecolouring":"loader_timecolouring__1l7OG"};